import { gql } from "@apollo/client";

const CREATE_CV_HISTORY = gql`
  mutation CreateCvHistory($createCvHistoryInput: CreateCvHistoryInput!) {
    createCvHistory(createCvHistoryInput: $createCvHistoryInput) {
      id
    }
  }
`;

const DELETE_CV_HISTORY = gql`
  mutation DeleteCvHistory($deleteCvHistoryId: String!) {
    deleteCvHistory(id: $deleteCvHistoryId) {
      id
    }
  }
`;

const CLONE_CV_HISTORY = gql`
  mutation CloneCvHistory($cloneCvHistoryId: String!) {
    cloneCvHistory(id: $cloneCvHistoryId) {
      id
    }
  }
`;

const UPDATE_CV_VERSION = gql`
  mutation UpdateCvVersion(
    $updateCvVersionId: String!
    $updateCvHistoryVersionInput: UpdateCvHistoryVersionInput!
  ) {
    updateCvVersion(
      id: $updateCvVersionId
      updateCvHistoryVersionInput: $updateCvHistoryVersionInput
    ) {
      id
    }
  }
`;

const DOWNLOAD_CV = gql`
  mutation DownloadCvVersion($downloadCvVersionId: String!, $lang: String!) {
    downloadCvVersion(id: $downloadCvVersionId, lang: $lang)
  }
`;

const TOGGLE_CV_MARKETPLACE = gql`
  mutation UpdateCvVersion(
    $updateCvVersionId: String!
    $updateCvHistoryVersionInput: UpdateCvHistoryVersionInput!
  ) {
    updateCvVersion(
      id: $updateCvVersionId
      updateCvHistoryVersionInput: $updateCvHistoryVersionInput
    ) {
      id
      definedForMarketplace
    }
  }
`;

const CONTACT_CANDIDATE = gql`
  mutation ContactCandidate(
    $cvId: String!
    $candidateName: String!
    $candidateRole: String!
    $contactName: String!
    $contactEmail: String!
  ) {
    contactCandidate(
      cvId: $cvId
      candidateName: $candidateName
      candidateRole: $candidateRole
      contactName: $contactName
      contactEmail: $contactEmail
    )
  }
`;

export const CREATE_CV_HISTORY_LANGUAGE = gql`
  mutation CloneCvVersionWithLanguage(
    $cloneCvVersionWithLanguageId: String!
    $lang: String!
  ) {
    cloneCvVersionWithLanguage(id: $cloneCvVersionWithLanguageId, lang: $lang) {
      id
    }
  }
`;

export default {
  CREATE_CV_HISTORY,
  DELETE_CV_HISTORY,
  CLONE_CV_HISTORY,
  UPDATE_CV_VERSION,
  DOWNLOAD_CV,
  CREATE_CV_HISTORY_LANGUAGE,
  TOGGLE_CV_MARKETPLACE,
  CONTACT_CANDIDATE
};
